export default function insights() {
  // Elements
  let featuredPosts = document.querySelector('.c-posts__featured');

  if (featuredPosts) {
    const allSlides = featuredPosts.querySelectorAll('.c-posts__post');
    const allDots = featuredPosts.querySelectorAll('.dot');
    let currentIndex = 0;

    const showSlide = (index) => {
      allSlides.forEach((slide, i) => {
        slide.classList.remove('active');
        if (i === index) {
            slide.classList.add('active');
        }
      });
      allDots.forEach((dot, i) => {
        dot.classList.remove('active');
        if (i === index) {
            dot.classList.add('active');
        }
      });
    };

    const nextSlide = () => {
      currentIndex = (currentIndex + 1) % allSlides.length;
      showSlide(currentIndex);
    };

    allDots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        let selected = parseInt(e.target.dataset.id, 10) - 1;
        clearInterval(intervalId);
        currentIndex = selected;
        showSlide(currentIndex);
      });
    });

    let intervalId = setInterval(nextSlide, 5000);
  }
}



// WEBPACK FOOTER //
// ./scripts/util/insights.js